<template lang="pug">
  .cart(v-if="cart")
    .page__wr
      Bread(v-if="cart.bread", :bread="cart.bread")
      .cart__title(v-if="h1") {{h1}}
      .cart__empty-wr(:style="(cartEmpty) ? '' : 'display: none'")
        .cart__empty
          img.cart__empty-decore-top(src="~@/assets/img/cart-empty-decore.png")
          img.cart__empty-decore-bottom(src="~@/assets/img/cart-empty-decore.png")
          .cart__empty-img-wr
            img.cart__empty-img(src="~@/assets/img/cart-empty.png")
            .cart__empty-text.cart__empty-text--red Ваша корзина пуста
            .cart__empty-text Приглашаем Вас#[br]посетить наше меню
          router-link.cart__empty-btn(to="/menyu") Перейти к выбору
      .cart__final-wr(:style="(cartFinal) ? '' : 'display: none'")
        .cart__final
          img.cart__final-decore(src="~@/assets/img/spot5.png")
          .cart__final-img-wr
            img.cart__final-img(src="~@/assets/img/cart-final.png")
            .cart__final-text Ваш заказ принят
          router-link.cart__final-btn(to="/") Вернуться на главную
      .cart__menu(:style="(cartEmpty || cartFinal) ? 'display: none' : ''")
        .cart__menu-list
          router-link.cart__menu-list-item.cart__menu-list-item--disabled(:to="item.link", v-if="cart.menu", v-for="item, index in cart.menu", :key="index", :data-cart-step-num="index + 1")
            .cart__menu-list-item-number
              SvgIcon.cart__menu-list-item-number-ico(v-if="item.icon", :name="item.icon", width="24", height="24")
            .cart__menu-list-item-title {{item.title}}
      .cart__items(:style="(cartEmpty || cartFinal) ? 'display: none' : ''")
        .cart__item(data-cart-step="vash-zakaz", data-cart-step-num="1")
          .cart__item-content
            YourOrder(v-if="yourOrder", :data="yourOrder")
        .cart__item(data-cart-step="adres-dostavki", data-cart-step-num="2")
          .cart__item-content
            DeliveryAddress(v-if="deliveryAddress", :data="deliveryAddress")
        .cart__item(data-cart-step="oplata", data-cart-step-num="3")
          .cart__item-content
            Payment(v-if="payment", :data="payment")
        .cart__item(data-cart-step="podtverzhdenie", data-cart-step-num="4")
          .cart__item-content
            Verification(v-if="verification", :data="verification")
        PreloaderImage
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/cart/cart.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Bread from '@/components/common/bread/bread.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';
  import YourOrder from '@/components/yourOrder/YourOrder.vue';
  import DeliveryAddress from '@/components/deliveryAddress/DeliveryAddress.vue';
  import Payment from '@/components/payment/Payment.vue';
  import Verification from '@/components/verification/Verification.vue';

  // @ is an alias to /src
  //import Events from '@/components/events/Events.vue';

export default {
  name: 'Cart',

  mixins: [AjaxHelpersVue, ImagePreloaderVue,  CartHelpersVue],

  data() {
    return {
      cart: null,
      content: {},
      ps: null,
      firstReq: true,
      cartEmpty: true,
      cartFinal: false,
      yourOrder: null,
      deliveryAddress: null,
      payment: null,
      verification: null,
      maxStep: 0,
    }
  },

  components: {
    SvgIcon,
    Bread,
    PreloaderImage,
    YourOrder,
    DeliveryAddress,
    Payment,
    Verification
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadCartPage', params => {
      this.request(params.url, params);
    });

    EventBus.$on('resetFirstReq', params => {
      this.firstReq = true;
    });

    EventBus.$on('setCartEmpty', params => {
      this.cartEmpty = true;
      this.firstReq = true;
    });
  },

  methods: {
    request(url, params) {
      let cartRoute = 'getYourOrder';
      let step = params.params.step || 'vash-zakaz';

      if(params.params.step === 'vash-zakaz') {
        cartRoute = 'getYourOrder';
      }
      else if(params.params.step === 'adres-dostavki') {
        cartRoute = 'getDeliveryAddress';
      }
      else if(params.params.step === 'oplata') {
        cartRoute = 'getPayment';
      }
      else if(params.params.step === 'podtverzhdenie') {
        cartRoute = 'getVerification';
      }
      else if(params.params.step === 'vypolnenie') {
        this.cartFinal = true;
        this.maxStep = 1;

        this.$nextTick(() => {
          $('.page__items').animate({'height': $('.page__item--active').outerHeight(true) + 'px'}, 250);
        });

        return false;
      }

      if(this.firstReq) {
        this.req('CartPage:getCartPage', {url: '/korzina'}, res => {
          this.firstReq = false;

          if(this.checkProperty(res.content)) {
            if(res.content.cartDisable) {
              window.location.href = '/';
              return false;
            }

            this.cart = res.content;
            this.cartEmpty = res.content.cartEmpty;
            this.cartFinal = false;
          }

          this.localReq(cartRoute, step, url);
        }, 'cart');
      }
      else {
        this.localReq(cartRoute, step, url);
      }

    },

    localReq(cartRoute, step, url) {
      if(this.cartEmpty) {
        return false;
      }

      this.$nextTick(() => {
        EventBus.$emit('preloaderShow', 'cart');
      });

      this.clearOldData();
      this.req(`CartPage:${cartRoute}`, {url}, res => {
        if(cartRoute === 'getYourOrder' && this.checkProperty(res.step)) {
          this.yourOrder = res;
        }
        else if(cartRoute === 'getDeliveryAddress' && this.checkProperty(res.step)) {
          this.deliveryAddress = res;
        }
        else if(cartRoute === 'getPayment' && this.checkProperty(res.step)) {
          this.payment = res;
        }
        else if(cartRoute === 'getVerification' && this.checkProperty(res.step)) {
          this.verification = res;
        }

        this.$nextTick(() => {
          this.getCartCount();
          this.setActiveBlock(step);
          EventBus.$emit('preloaderHide', 'cart');
        });
      }, '', 'localPageRequest');
    },

    clearOldData() {
      this.yourOrder = null;
      this.deliveryAddress = null;
      this.payment = null;
      this.verification = null;
    },

    setActiveBlock(step) {
      let num = $(`[data-cart-step="${step}"]`).data('cart-step-num');
      let count = $('.header__cart-count').text();

      if(count == 0) {
        num = 1;
        this.maxStep = 1;
      }

      if(this.maxStep < num) {
        this.maxStep = num;
      }

      $('.cart__item--active').removeClass('cart__item--active').removeClass('cart__item--anima');
      $(`.cart__item[data-cart-step="${step}"]`).addClass('cart__item--active');

      setTimeout(() => {
        $(`[data-cart-step="${step}"]`).addClass('cart__item--anima');
        $('.cart__items').css({'height': $('.cart__item--active').find('.cart__item-content').height() + 'px'});
        $('.page__items').animate({'height': $('.page__item--active').outerHeight(true) + 'px'}, 250);
      }, 250);

      $('.cart__menu-list-item--active').removeClass('cart__menu-list-item--active');
      $(`.cart__menu-list-item[data-cart-step-num="${num}"]`).addClass('cart__menu-list-item--active').removeClass('cart__menu-list-item--disabled');

      $('.cart__menu-list-item').each((i, el) => {
        if($(el).data('cart-step-num') > this.maxStep) {
          $(el).addClass('cart__menu-list-item--disabled');
        } else {
          $(el).removeClass('cart__menu-list-item--disabled');
        }
      });
    },
  }
}
</script>
